import { render, staticRenderFns } from "./StadiumBoostCreateAndUpdateFormItems.vue?vue&type=template&id=2f505264&"
import script from "./StadiumBoostCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./StadiumBoostCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f505264')) {
      api.createRecord('2f505264', component.options)
    } else {
      api.reload('2f505264', component.options)
    }
    module.hot.accept("./StadiumBoostCreateAndUpdateFormItems.vue?vue&type=template&id=2f505264&", function () {
      api.rerender('2f505264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostCreateAndUpdateFormItems.vue"
export default component.exports